/**
 * @generated SignedSource<<394b1aad6170a1c0196c63b7798b6262>>
 * @relayHash 6a9e6b67a185bb8f23ce7cfb293c45db
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6a9e6b67a185bb8f23ce7cfb293c45db

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MarkNotificationAsReadInput = {
  clientMutationId?: string | null;
  id: string;
};
export type markNotificationAsReadIssueViewerMutation$variables = {
  input: MarkNotificationAsReadInput;
};
export type markNotificationAsReadIssueViewerMutation$data = {
  readonly markNotificationAsRead: {
    readonly notificationThread: {
      readonly id: string;
      readonly isUnread: boolean;
    } | null;
    readonly success: boolean | null;
  } | null;
};
export type markNotificationAsReadIssueViewerMutation$rawResponse = {
  readonly markNotificationAsRead: {
    readonly notificationThread: {
      readonly id: string;
      readonly isUnread: boolean;
    } | null;
    readonly success: boolean | null;
  } | null;
};
export type markNotificationAsReadIssueViewerMutation = {
  rawResponse: markNotificationAsReadIssueViewerMutation$rawResponse;
  response: markNotificationAsReadIssueViewerMutation$data;
  variables: markNotificationAsReadIssueViewerMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkNotificationAsReadPayload",
    "kind": "LinkedField",
    "name": "markNotificationAsRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationThread",
        "kind": "LinkedField",
        "name": "notificationThread",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isUnread",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markNotificationAsReadIssueViewerMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markNotificationAsReadIssueViewerMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6a9e6b67a185bb8f23ce7cfb293c45db",
    "metadata": {},
    "name": "markNotificationAsReadIssueViewerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b7867055255dbbd3b348b803954ba26f";

export default node;
